import React from 'react';
import ReactDOM from 'react-dom';
import App from './snapit_app/components/App';
import styles from './styles.css'; // eslint-disable-line no-unused-vars

window.setCookie = function(c_name, value, exdays){
  var exdate = new Date();
  exdate.setDate( exdate.getDate() + exdays );
  var c_value = escape( value ) + ( ( exdays == null ) ? "" : "; expires=" + exdate.toUTCString() );
  document.cookie = c_name + "=" + c_value + "; path=/";
}

window.getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

if (window.getCookie("udid") === ""){

  function udid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  window.setCookie("udid",udid(),200)
}

if ((typeof navigator === 'undefined') || !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
  console.log("enumerateDevices() not supported.");
}

// List cameras and microphones.

if ((typeof navigator !== "undefined") && (typeof navigator.mediaDevices !== "undefined")){
  navigator.mediaDevices.enumerateDevices()
    .then(function(devices) {
      //var output = "";
      devices.forEach(function(device) {
        if (device.kind === 'audioinput'){
          //output += ("......" + device.kind + ": " + device.label +
          //" id = " + device.deviceId);
          window.setCookie("audio_id", device.deviceId, 345);
        }
        if (device.kind === 'videoinput'){
          //output += ("......" + device.kind + ": " + device.label +
          //" id = " + device.deviceId);
          window.setCookie("camera_id", device.deviceId, 345);
        }
      });

      // var p = document.createElement("p");
      // p.innerHTML = output;
      // p.style = "color:white;";
      // document.body.appendChild(p);

    })
    .catch(function(err) {
      console.log(err.name + ": " + err.message);
    });
}



ReactDOM.render(
  <App />,
  document.getElementById('root')
);





// WEBPACK FOOTER //
// ./src/index.js